import {Inject, Injectable} from '@angular/core';
import {LocalStoreService} from './local-store.service';
import {LOCAL_STORAGE, StorageService} from 'angular-webstorage-service';
import {Router} from '@angular/router';
import {of} from 'rxjs';
import {delay} from 'rxjs/operators';
import {SessionStorageService} from './session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    authenticated = false;

    constructor(@Inject(LOCAL_STORAGE) private storage: StorageService,
                private store: LocalStoreService,
                private router: Router,
                public sessionStorageService: SessionStorageService) {
    }

    signin() {
        this.authenticated = true;
        return of({}).pipe(delay(1500));
    }

    signout() {
        this.authenticated = false;
        this.sessionStorageService.removeUserSession();
        // this.sessionStorageService.removeLanguageSession();
        this.router.navigate(['sessions', 'signin']);
    }

}
